'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconGridThreeByThree, iconGridThreeByThreeTag } from '@ni/nimble-components/dist/esm/icons/grid-three-by-three';
import { wrap } from '../../utilities/react-wrapper';

export type { IconGridThreeByThree };
export { iconGridThreeByThreeTag };
export const NimbleIconGridThreeByThree = wrap(IconGridThreeByThree);